export default __webpack_public_path__ + "static/media/run-payroll-initial.6128ec6a.svg";